import { defineSlotRecipe } from '@chakra-ui/react'
import {
  alPrimaryTeal,
  alTeal5,
  alRed,
  alWhite,
  alOrange,
  alOrange5,
} from '@reward-platform/lift/theme/aer_lingus/variables'

export const label = defineSlotRecipe({
  className: 'Label',
  slots: ['labelContainer'],
  variants: {
    variant: {
      success: {
        labelContainer: {
          color: alPrimaryTeal,
          backgroundColor: alTeal5,
        },
      },
      error: {
        labelContainer: {
          color: alRed,
          backgroundColor: alWhite,
        },
      },
      warning: {
        labelContainer: {
          color: alOrange,
          backgroundColor: alOrange5,
        },
      },
    },
  },
  defaultVariants: {
    variant: 'success',
  },
})
